import { render, staticRenderFns } from "./uploadBlock.vue?vue&type=template&id=2f022ba8"
import script from "./uploadBlock.vue?vue&type=script&lang=js"
export * from "./uploadBlock.vue?vue&type=script&lang=js"
import style0 from "./uploadBlock.vue?vue&type=style&index=0&id=2f022ba8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports